import { array, arrayOf, bool, func, node, objectOf, oneOfType, shape, string } from 'prop-types';
import { Field } from 'react-final-form';
import MaskedInput from 'react-text-mask';
import { getErrors } from 'utils/old-ui-commons/input-label-error';

import { Input } from '@olist/united';

const SignupInput = ({
  handleErrorMessages,
  handleLabel,
  initialErrors,
  mask,
  name,
  onBlur = () => {},
  styleOnError,
  ...rest
}) => {
  const handleBlur = (input, meta) => (event) => {
    input.onBlur(event);
    onBlur(event, input, meta);
  };

  return (
    <Field {...rest} name={name}>
      {({ input, meta }) => {
        const errors = getErrors(meta, initialErrors[input.name]);
        const hasErrors = !!errors;
        const errorsStyles = hasErrors ? styleOnError : {};
        const hasMask = !!mask;
        const shouldShowErrors = hasErrors && !!handleErrorMessages;
        return (
          <>
            {handleLabel}
            {hasMask ? (
              <MaskedInput
                style={errorsStyles}
                error={hasErrors}
                id={input.name}
                data-testid="maskedInput"
                mask={mask}
                onBlur={handleBlur(input, meta)}
                render={(ref, props) => (
                  <Input
                    ref={ref}
                    {...props}
                    {...rest}
                    {...input}
                    onChange={rest.onChange}
                    maxLengh={rest.maxLengh}
                  />
                )}
              />
            ) : (
              <Input
                {...rest}
                {...input}
                style={errorsStyles}
                data-testid="defaultInput"
                error={hasErrors}
                id={input.name}
                onBlur={handleBlur(input, meta)}
              />
            )}

            {shouldShowErrors && handleErrorMessages(errors)}
          </>
        );
      }}
    </Field>
  );
};

SignupInput.defaultProps = {
  handleErrorMessages: null,
  initialErrors: {},
  mask: null,
  onBlur: () => {},
  styleOnError: null,
  handleLabel: null,
};

SignupInput.propTypes = {
  handleErrorMessages: func,
  handleLabel: node,
  initialErrors: arrayOf(shape({})),
  mask: oneOfType([
    array,
    func,
    bool,
    shape({
      mask: oneOfType([array, func]),
      pipe: func,
    }),
  ]),
  name: string.isRequired,
  onBlur: func,
  styleOnError: objectOf(string),
};

export default SignupInput;
